import { Controller } from "stimulus";
import { EventCheckUserLogin } from "../events";

export default class extends Controller {
  static targets = ["candyIcon", "candyNotificationIcon", "candyNotificationIconMobile", "loggedInNavi", "loggedOutNavi", "userName", "beam", "form"];

  connect() {
    fetch("/accounts/csrf_meta.json", { credentials: "same-origin" })
      .then(response => response.json())
      .then(json => {
        $("<meta>")
          .attr("name", "csrf-param")
          .attr("content", json.param)
          .appendTo("head");

        $("<meta>")
          .attr("name", "csrf-token")
          .attr("content", json.token)
          .appendTo("head");

        // add latest CSFR token to user sign in modal
        this._assignCSRFTokenToModalForm(json.token);
      })
      .then(function() {
        return fetch("/accounts/logged_in_user.json", { credentials: "same-origin" });
      })
      .then(response => response.json())
      .then(json => {
        if (json.current_user) {
          const name = json.current_user.name || json.current_user.email;
          const candyRedemptionAvailable = json.candy_redemption_available;
          this.userNameTargets.forEach(e => {
            e.textContent = name;
          });
          this._showLoggedInNavi(true);
          this._showLoggedOutNavi(false);
          this._showCandyIcon(true);
          this._showCandyNotificationIcon(candyRedemptionAvailable);
          this._showBeamNavi(json.beam_enabled);
          this._dispatchCheckUserLoginEvent(true);
        } else {
          this._showLoggedInNavi(false);
          this._showLoggedOutNavi(true);
          this._showCandyIcon(false);
          this._showCandyNotificationIcon(false);
          this._showBeamNavi(false);
          this._dispatchCheckUserLoginEvent(false);
        }
      });
  }

  _showCandyNotificationIcon(candyRedemptionAvailable){
    if(candyRedemptionAvailable === true) {
      this.candyNotificationIconTargets.forEach(e => {
        e.classList.remove("d-none");
      });
    }
  }

  _showCandyIcon(isLoggedIn){
    if(isLoggedIn === false) {
      this.candyIconTargets.forEach(e => {
        e.href = "#";
        e.dataset.target = "#signInModal";
        e.dataset.toggle = "modal";
      });
    }
  }
  _showBeamNavi(show) {
    this.beamTargets.forEach(e => {
      show ? e.classList.remove("d-none") : e.classList.add("d-none");
    });
  }

  _showLoggedInNavi(show) {
    this.loggedInNaviTargets.forEach(e => {
      show ? e.classList.remove("d-none") : e.classList.add("d-none");
    });
  }

  _showLoggedOutNavi(show) {
    this.loggedOutNaviTargets.forEach(e => {
      show ? e.classList.remove("d-none") : e.classList.add("d-none");
    });
  }

  _assignCSRFTokenToModalForm(token) {
    this.formTargets.forEach(target => {
      var tokenHiddenField = document.createElement("input");
      tokenHiddenField.setAttribute("type", "hidden");
      tokenHiddenField.setAttribute("name", "authenticity_token");
      tokenHiddenField.setAttribute("value", token);
      target.appendChild(tokenHiddenField);
    });
  }

  _dispatchCheckUserLoginEvent(value) {
    window.dispatchEvent(
      new CustomEvent(EventCheckUserLogin, {
        detail: {
          userLoggedIn: value
        }
      })
    );
  }
}
